const MAIN_SCROLL_SELECTOR = '[data-main-scroll]'

export function scrollAppToTop() {
  const container = document.querySelector(MAIN_SCROLL_SELECTOR)
  if (container instanceof HTMLElement) {
    container.scrollTop = 0
  }
  window.scrollTo(0, 0)
}
